import { lazy } from 'react';

// project imports
import DocumentLayout from 'layout/DocumentLayout';
import Loadable from 'ui-component/Loadable';

// document routing
const Document = Loadable(lazy(() => import('views/Document/index')));


const DocumentRoutes = {
  path: '/panel',
  element: <DocumentLayout />,
  children: [
    {
      path: 'document',
      element: <Document />
    }
  ]
};

export default DocumentRoutes;
